import { render } from "./Frontend.vue?vue&type=template&id=7e4f4e4c&scoped=true"
import script from "./Frontend.vue?vue&type=script&lang=js"
export * from "./Frontend.vue?vue&type=script&lang=js"

import "./Frontend.vue?vue&type=style&index=0&id=7e4f4e4c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7e4f4e4c"

export default script